"use client";

import dynamic from "next/dynamic";
import LandingHeroNav from "@/features/landing/components/LandingHeroNav";
import LandingFeaturesCarousel from "@/features/landing/components/LandingFeaturesCarousel";

// Below-the-fold sections — lazy-loaded to reduce initial JS bundle
const LandingTeam = dynamic(
  () => import("@/features/landing/components/LandingTeam"),
);
const LandingTestimonials = dynamic(
  () => import("@/features/landing/components/LandingTestimonials"),
);
const LandingFAQ = dynamic(
  () => import("@/features/landing/components/LandingFAQ"),
);
const LandingSupportCTA = dynamic(
  () => import("@/features/landing/components/LandingSupportCTA"),
);
const LandingFooter = dynamic(
  () => import("@/features/landing/components/LandingFooter"),
);

export default function HomePageClient() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <LandingHeroNav />
      <LandingFeaturesCarousel />
      <LandingTeam />
      <LandingTestimonials />
      <LandingFAQ />
      <LandingSupportCTA />
      <LandingFooter />
    </div>
  );
}
